const MAPS_STACK_HINT = /maps-api-v3|maps\.googleapis\.com|google\.maps|\/marker\.js|\/common\.js/i;

const TEARDOWN_MESSAGE_PATTERNS = [
  /Argument 1 \('target'\) to IntersectionObserver\.observe must be an instance of Element/i,
  /evaluating [''].+\.getRootNode['']/i,
  /evaluating [''].+\.keys['']/i,
  /null is not an object \(evaluating .+\.getRootNode\)/i,
  /undefined is not an object \(evaluating .+\.getRootNode\)/i,
  /null is not an object \(evaluating .+\.keys\)/i,
  /undefined is not an object \(evaluating .+\.keys\)/i,
];

function errorText(error: unknown): string {
  if (error instanceof Error) {
    return `${error.name}: ${error.message}\n${error.stack ?? ''}`;
  }
  return String(error);
}

/**
 * Benign Google Maps teardown errors that fire after AdvancedMarker/map
 * cleanup on Mobile Safari. Drop these in Sentry beforeSend so they do not
 * page overnight on single-event noise.
 */
export function isBenignMapsTeardownError(error: unknown): boolean {
  const text = errorText(error);
  if (!TEARDOWN_MESSAGE_PATTERNS.some((pattern) => pattern.test(text))) {
    return false;
  }

  if (MAPS_STACK_HINT.test(text)) {
    return true;
  }

  // IntersectionObserver guard misses still match the known observe() message.
  return /IntersectionObserver\.observe must be an instance of Element/i.test(text);
}
